import {Form, Field, ErrorMessage} from 'vee-validate';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component("V-Form",Form);
    nuxtApp.vueApp.component("V-Field",Field);
    nuxtApp.vueApp.component("V-ErrorMessage",ErrorMessage);
})